export default __webpack_public_path__ + "static/media/Florence@2x.67fe5afb.jpg";